
(function(){
  function markHeader(root){
    if(!root)return;
    var group=root.closest('#header-group'),wrapper=root.closest('.shopify-section');
    if(group)group.classList.add('ps-header-group-active');
    if(wrapper)wrapper.classList.add('ps-header-section-wrapper');
    if(!root.__psOffsetObserved){
      var syncOffset=function(){if(root.isConnected)document.documentElement.style.setProperty('--ps-header-offset',(Math.ceil(root.getBoundingClientRect().height)+16)+'px')};
      syncOffset();
      if(window.ResizeObserver){var observer=new ResizeObserver(syncOffset);observer.observe(root);root.__psOffsetObserver=observer}
      else{window.addEventListener('resize',syncOffset)}
      root.__psOffsetObserved=true;
    }
  }
  function markAll(){document.querySelectorAll('.ps-header').forEach(markHeader)}
  if(window.__psHeaderNavigationV1947){markAll();return}
  function closeResources(except){document.querySelectorAll('[data-ps-resource][open]').forEach(function(item){if(item!==except)item.removeAttribute('open')})}
  function setDrawer(root,open,returnFocus){
    if(!root)return;
    var b=root.querySelector('[data-ps-burger]'),d=root.querySelector('[data-open]');
    if(!b||!d)return;
    d.setAttribute('data-open',open?'true':'false');
    b.setAttribute('aria-expanded',open?'true':'false');
    if(open){var f=d.querySelector('a');if(f)f.focus()}else if(returnFocus)b.focus();
  }
  window.__psHeaderNavigationV1947={markAll:markAll};
  markAll();
  document.addEventListener('click',function(e){
    var burger=e.target.closest('[data-ps-burger]');
    if(burger){var root=burger.closest('.ps-header'),drawer=root&&root.querySelector('[data-open]');setDrawer(root,drawer&&drawer.getAttribute('data-open')!=='true',false);return}
    var current=e.target.closest('[data-ps-resource]');
    closeResources(current);
    if(current&&e.target.closest('a'))current.removeAttribute('open');
    var openDrawer=e.target.closest('.ps-header__drawer[data-open="true"]');
    if(openDrawer&&e.target.closest('a'))setDrawer(openDrawer.closest('.ps-header'),false,false);
  });
  document.addEventListener('keydown',function(e){
    if(e.key!=='Escape')return;
    closeResources();
    document.querySelectorAll('.ps-header').forEach(function(root){var d=root.querySelector('[data-open="true"]');if(d)setDrawer(root,false,true)});
  });
  document.addEventListener('shopify:section:load',markAll);
  document.addEventListener('shopify:section:unload',function(e){e.target.querySelectorAll('.ps-header').forEach(function(root){if(root.__psOffsetObserver)root.__psOffsetObserver.disconnect()})});
  if(window.matchMedia){var m=window.matchMedia('(min-width: 990px)'),r=function(e){if(!e.matches)return;closeResources();document.querySelectorAll('.ps-header').forEach(function(root){setDrawer(root,false,false)})};m.addEventListener?m.addEventListener('change',r):m.addListener&&m.addListener(r)}
})();
